import { __ } from "@wordpress/i18n"
import { 
  useBlockProps, 
  InspectorControls,
  RichText,
  MediaUpload,
  MediaUploadCheck
} from "@wordpress/block-editor"
import { 
  PanelBody,
  Button
} from "@wordpress/components"
import ServerSideRender from "@wordpress/server-side-render"
import { useState } from "@wordpress/element"
import { registerBlockType } from "@wordpress/blocks"

function Edit({ attributes, setAttributes, clientId }) {
  const blockProps = useBlockProps({
    className: `icon-hero ${attributes.align ? `align${attributes.align}` : ''}`
  })

  const [isEditing, setIsEditing] = useState(false)

  // If we're editing, show the rich text editors instead of ServerSideRender
  if (isEditing) {
    return (
      <>
        <InspectorControls>
          <PanelBody title={__('Icon Hero Settings', 'puroclean-tw')} initialOpen={true}>
            {/* Icon Upload */}
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
                {__('Icon (SVG):', 'puroclean-tw')}
              </label>
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={(media) => setAttributes({ 
                    icon: {
                      url: media.url,
                      id: media.id,
                      alt: media.alt || 'Icon'
                    }
                  })}
                  allowedTypes={['image']}
                  value={attributes.icon.id}
                  render={({ open }) => (
                    <div>
                      {attributes.icon.url ? (
                        <div>
                          <img 
                            src={attributes.icon.url} 
                            alt={attributes.icon.alt}
                            style={{ maxWidth: '80px', maxHeight: '80px', marginBottom: '10px', display: 'block' }}
                          />
                          <Button onClick={open} variant="secondary" style={{ marginRight: '10px' }}>
                            {__('Change Icon', 'puroclean-tw')}
                          </Button>
                          <Button 
                            onClick={() => setAttributes({ 
                              icon: { url: '', id: 0, alt: 'Icon' }
                            })} 
                            variant="link" 
                            isDestructive
                          >
                            {__('Remove Icon', 'puroclean-tw')}
                          </Button>
                        </div>
                      ) : (
                        <Button onClick={open} variant="secondary">
                          {__('Upload SVG Icon', 'puroclean-tw')}
                        </Button>
                      )}
                    </div>
                  )}
                />
              </MediaUploadCheck>
              <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                {__('Upload an SVG file for your icon. If no icon is uploaded, a default icon will be used.', 'puroclean-tw')}
              </p>
            </div>
          </PanelBody>
        </InspectorControls>

        <div {...blockProps}>
          <div style={{ 
            border: '2px dashed #ddd', 
            padding: '40px 20px', 
            textAlign: 'center',
            backgroundColor: '#f9f9f9'
          }}>
            <h3 style={{ marginBottom: '20px', color: '#333' }}>
              {__('Icon Hero Block - Edit Mode', 'puroclean-tw')}
            </h3>
            
            {/* Icon Preview */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              marginBottom: '20px' 
            }}>
              <div style={{ 
                backgroundColor: '#1f2937', 
                color: 'white', 
                padding: '16px', 
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '64px',
                minHeight: '64px'
              }}>
                {attributes.icon.url ? (
                  <img 
                    src={attributes.icon.url} 
                    alt={attributes.icon.alt}
                    style={{ width: '32px', height: '32px', filter: 'brightness(0) invert(1)' }}
                  />
                ) : (
                  <span style={{ fontSize: '32px' }}>🤝</span>
                )}
              </div>
            </div>
            
            <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'left' }}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
                  {__('Title (H1):', 'puroclean-tw')}
                </label>
                <RichText
                  tagName="div"
                  placeholder={__('Enter hero title...', 'puroclean-tw')}
                  value={attributes.title}
                  onChange={(value) => setAttributes({ title: value })}
                  style={{ 
                    border: '1px solid #ddd', 
                    padding: '12px', 
                    minHeight: '50px',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    backgroundColor: 'white'
                  }}
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
                  {__('Subtitle (text-primary, optional):', 'puroclean-tw')}
                </label>
                <RichText
                  tagName="div"
                  placeholder={__('Enter subtitle (optional)...', 'puroclean-tw')}
                  value={attributes.subtitle}
                  onChange={(value) => setAttributes({ subtitle: value })}
                  style={{ 
                    border: '1px solid #ddd', 
                    padding: '12px', 
                    minHeight: '50px',
                    fontSize: '16px',
                    backgroundColor: 'white'
                  }}
                />
              </div>
              
              <div style={{ marginBottom: '30px' }}>
                <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
                  {__('Comment (optional):', 'puroclean-tw')}
                </label>
                <RichText
                  tagName="div"
                  placeholder={__('Enter additional comment (optional)...', 'puroclean-tw')}
                  value={attributes.comment}
                  onChange={(value) => setAttributes({ comment: value })}
                  style={{ 
                    border: '1px solid #ddd', 
                    padding: '12px', 
                    minHeight: '60px',
                    fontSize: '14px',
                    backgroundColor: 'white'
                  }}
                />
              </div>
              
              <div style={{ textAlign: 'center' }}>
                <button
                  onClick={() => setIsEditing(false)}
                  style={{
                    backgroundColor: '#0073aa',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px'
                  }}
                >
                  {__('Done Editing - View Preview', 'puroclean-tw')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  // Show preview mode with ServerSideRender
  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Icon Hero Settings', 'puroclean-tw')} initialOpen={true}>
          <button
            onClick={() => setIsEditing(true)}
            style={{
              backgroundColor: '#0073aa',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '15px'
            }}
          >
            {__('Edit Content', 'puroclean-tw')}
          </button>
          
          {/* Icon Upload */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
              {__('Icon (SVG):', 'puroclean-tw')}
            </label>
            <MediaUploadCheck>
              <MediaUpload
                onSelect={(media) => setAttributes({ 
                  icon: {
                    url: media.url,
                    id: media.id,
                    alt: media.alt || 'Icon'
                  }
                })}
                allowedTypes={['image']}
                value={attributes.icon.id}
                render={({ open }) => (
                  <div>
                    {attributes.icon.url ? (
                      <div>
                        <img 
                          src={attributes.icon.url} 
                          alt={attributes.icon.alt}
                          style={{ maxWidth: '80px', maxHeight: '80px', marginBottom: '10px', display: 'block' }}
                        />
                        <Button onClick={open} variant="secondary" style={{ marginRight: '10px' }}>
                          {__('Change Icon', 'puroclean-tw')}
                        </Button>
                        <Button 
                          onClick={() => setAttributes({ 
                            icon: { url: '', id: 0, alt: 'Icon' }
                          })} 
                          variant="link" 
                          isDestructive
                        >
                          {__('Remove Icon', 'puroclean-tw')}
                        </Button>
                      </div>
                    ) : (
                      <Button onClick={open} variant="secondary">
                        {__('Upload SVG Icon', 'puroclean-tw')}
                      </Button>
                    )}
                  </div>
                )}
              />
            </MediaUploadCheck>
            <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
              {__('Upload an SVG file for your icon. If no icon is uploaded, a default icon will be used.', 'puroclean-tw')}
            </p>
          </div>
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        <ServerSideRender
          block="puroclean/icon-hero"
          attributes={attributes}
          urlQueryArgs={{ context: 'edit' }}
        />
      </div>
    </>
  )
}

registerBlockType('puroclean/icon-hero', {
  edit: Edit,
  save() {
    return null; // Server-side rendered
  }
}); 